/**
 * LORSA Wishlist — favoritos em localStorage, sem login.
 * - Botões: [data-wishlist-button][data-product-handle]
 * - Página de favoritos: [data-wishlist-grid]
 */
(function () {
  var KEY = 'lorsa_wishlist';

  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) { /* modo privado etc. */ }
  }

  function has(handle) {
    return read().indexOf(handle) !== -1;
  }

  function toggle(handle) {
    var list = read();
    var i = list.indexOf(handle);
    if (i === -1) {
      list.unshift(handle);
    } else {
      list.splice(i, 1);
    }
    write(list);
    syncButtons();
    var added = i === -1;
    onListChanged(added, list.length);
    return added;
  }

  function syncButtons(root) {
    var scope = root || document;
    var list = read();
    var buttons = scope.querySelectorAll('[data-wishlist-button]');
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      var active = list.indexOf(btn.getAttribute('data-product-handle')) !== -1;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-wishlist-button]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var added = toggle(btn.getAttribute('data-product-handle'));
    btn.classList.add(added ? 'wishlist-button--pop' : 'wishlist-button--unpop');
    setTimeout(function () {
      btn.classList.remove('wishlist-button--pop', 'wishlist-button--unpop');
    }, 400);
  });

  /* Cards carregados dinamicamente (slider, infinite scroll, quick view) */
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var nodes = mutations[i].addedNodes;
      for (var j = 0; j < nodes.length; j++) {
        var node = nodes[j];
        if (node.nodeType !== 1) continue;
        if (node.matches && node.matches('[data-wishlist-button]')) {
          syncButtons(node.parentNode || document);
        } else if (node.querySelector && node.querySelector('[data-wishlist-button]')) {
          syncButtons(node);
        }
      }
    }
  });

  function init() {
    syncButtons();
    observer.observe(document.body, { childList: true, subtree: true });
    renderWishlistPage();
    initDrawer();
    tameWhatsappWidget();
  }

  /* ---------- Widget do WhatsApp (app GTY, shadow DOM aberto) ----------
     O app não expõe tamanho/posição por CSS externo; injetamos um <style> no
     shadow root pra ele ficar com 52px nos cantos (22px desktop / 16px mobile),
     alinhado com a bolinha de favoritos logo acima. */
  var WA_TAG = 'gty-whatsapp-chat-button';
  var WA_CSS =
    '.gty-wacb-wrapper{right:22px!important;bottom:22px!important;transform:none!important}' +
    '.gty-wacb-button{width:52px!important;height:52px!important;box-shadow:0 6px 18px rgba(0,0,0,.14)}' +
    '.gty-wacb-button svg{width:28px!important;height:28px!important}' +
    '@media (max-width:749px){.gty-wacb-wrapper{right:16px!important;bottom:16px!important}}';

  function styleWhatsapp(host) {
    if (!host || !host.shadowRoot || host.shadowRoot.querySelector('[data-lorsa-wa]')) return true;
    var style = document.createElement('style');
    style.setAttribute('data-lorsa-wa', '');
    style.textContent = WA_CSS;
    host.shadowRoot.appendChild(style);
    return true;
  }

  function tameWhatsappWidget() {
    var tries = 0;
    (function attempt() {
      var host = document.querySelector(WA_TAG);
      if (host && host.shadowRoot) { styleWhatsapp(host); }
      if (++tries < 40) setTimeout(attempt, 500); // o app carrega tarde; reaplica se recriar o shadow
    })();
  }

  /* ---------- Bolinha flutuante + painel ---------- */

  var INTRO_KEY = 'lorsa_wishlist_intro'; // abre sozinho só na 1ª peça favoritada, uma vez
  var drawer = null;
  var productCache = {};

  function fetchProduct(handle) {
    if (productCache[handle]) return productCache[handle];
    productCache[handle] = fetch('/products/' + handle + '.js')
      .then(function (r) { if (!r.ok) throw new Error('not found'); return r.json(); })
      .catch(function () { delete productCache[handle]; return null; });
    return productCache[handle];
  }

  function imgUrl(src, width) {
    if (!src) return '';
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function initDrawer() {
    var root = document.querySelector('[data-wishlist-drawer-root]');
    if (!root) return;
    drawer = {
      root: root,
      fab: root.querySelector('[data-wishlist-fab]'),
      list: root.querySelector('[data-wishlist-list]'),
      empty: root.querySelector('[data-wishlist-drawer-empty]'),
      count: root.querySelector('[data-wishlist-count]'),
      countText: root.querySelector('[data-wishlist-count-text]'),
      panel: root.querySelector('.wl-drawer')
    };

    /* Sem bolinha na própria página de favoritos */
    if (document.querySelector('[data-wishlist-grid]')) root.classList.add('wl-root--hidden');

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-wishlist-fab]')) { toggleDrawer(); return; }
      if (e.target.closest('[data-wishlist-close]')) { closeDrawer(); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) closeDrawer();
    });

    updateCount();
  }

  function updateCount() {
    if (!drawer) return;
    var n = read().length;
    drawer.count.textContent = n;
    drawer.countText.textContent = n ? (n + (n === 1 ? ' peça' : ' peças')) : '';
    drawer.fab.classList.toggle('has-items', n > 0);
  }

  function openDrawer() {
    if (!drawer) return;
    renderDrawer();
    drawer.root.classList.add('is-open');
    drawer.fab.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('wl-lock');
    setTimeout(function () { drawer.panel.focus(); }, 50);
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.root.classList.remove('is-open');
    drawer.fab.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('wl-lock');
  }

  function toggleDrawer() {
    if (!drawer) return;
    drawer.root.classList.contains('is-open') ? closeDrawer() : openDrawer();
  }

  function onListChanged(added, total) {
    updateCount();
    if (!drawer) return;
    if (drawer.root.classList.contains('is-open')) {
      renderDrawer();
      return;
    }
    /* 1ª peça favoritada da vida: mostra onde ela foi parar */
    var seenIntro = false;
    try { seenIntro = !!localStorage.getItem(INTRO_KEY); } catch (e) {}
    if (added && total === 1 && !seenIntro) {
      try { localStorage.setItem(INTRO_KEY, '1'); } catch (e) {}
      openDrawer();
    }
  }

  function renderDrawer() {
    if (!drawer) return;
    var handles = read();
    drawer.list.innerHTML = '';
    drawer.empty.hidden = handles.length > 0;
    if (!handles.length) return;

    handles.forEach(function (handle) {
      var row = document.createElement('div');
      row.className = 'wl-item';
      row.setAttribute('data-handle', handle);
      row.innerHTML = '<div class="wl-item__img wl-item__img--loading"></div><div class="wl-item__body"></div>';
      drawer.list.appendChild(row);

      fetchProduct(handle).then(function (p) {
        if (!p) { row.remove(); return; }
        var price = formatMoney(p.price);
        var old = p.compare_at_price && p.compare_at_price > p.price ? '<s>' + formatMoney(p.compare_at_price) + '</s>' : '';
        var img = p.featured_image ? '<img src="' + imgUrl(p.featured_image, 240) + '" loading="lazy" alt="">' : '';
        row.innerHTML =
          '<a class="wl-item__img" href="/products/' + handle + '">' + img + '</a>' +
          '<div class="wl-item__body">' +
            '<a class="wl-item__title" href="/products/' + handle + '">' + p.title + '</a>' +
            '<div class="wl-item__price">' + price + old + '</div>' +
          '</div>' +
          '<button type="button" class="wl-remove" data-wishlist-button data-product-handle="' + handle + '" aria-label="Remover dos favoritos">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" width="18" height="18" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>' +
          '</button>';
      });
    });
  }

  /* ---------- Página de favoritos ---------- */

  function formatMoney(cents) {
    try {
      return (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    } catch (e) {
      return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',');
    }
  }

  function renderWishlistPage() {
    var grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) return;

    var empty = document.querySelector('[data-wishlist-empty]');
    var handles = read();

    if (!handles.length) {
      if (empty) empty.hidden = false;
      grid.hidden = true;
      return;
    }
    if (empty) empty.hidden = true;
    grid.hidden = false;
    grid.innerHTML = '';

    handles.forEach(function (handle) {
      fetch('/products/' + handle + '.js')
        .then(function (r) {
          if (!r.ok) throw new Error('not found');
          return r.json();
        })
        .then(function (p) {
          var item = document.createElement('div');
          item.className = 'wishlist-page__item';
          var img = p.featured_image
            ? '<img src="' + p.featured_image + '&width=600" loading="lazy" alt="">'
            : '';
          if (p.featured_image && p.featured_image.indexOf('?') === -1) {
            img = '<img src="' + p.featured_image + '?width=600" loading="lazy" alt="">';
          }
          item.innerHTML =
            '<div class="wishlist-page__item__image"><a href="/products/' + handle + '">' + img + '</a>' +
            '<button type="button" class="wishlist-button is-active" data-wishlist-button data-product-handle="' + handle + '" aria-label="Remover dos favoritos">' +
            document.querySelector('[data-wishlist-icon-template]').innerHTML +
            '</button></div>' +
            '<a class="wishlist-page__item__title" href="/products/' + handle + '">' + p.title + '</a>' +
            '<span class="wishlist-page__item__price">' + formatMoney(p.price) + '</span>';
          grid.appendChild(item);

          /* Ao remover na própria página, some o card */
          item.querySelector('[data-wishlist-button]').addEventListener('click', function () {
            setTimeout(function () {
              item.remove();
              if (!read().length) {
                if (empty) empty.hidden = false;
                grid.hidden = true;
              }
            }, 350);
          });
        })
        .catch(function () { /* produto removido da loja — ignora */ });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
